import React, { useState, useEffect } from 'react';

function useResizeView(fnc: () => void, trigger: any) {
  const delay = 300;
  let timer;

  useEffect(() => {
    function onResize() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fnc();
      }, delay);
    }

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [trigger]);
}

export default useResizeView;
